export type BillingsTaxiDriverUpdateParamsNode = {
  uuid: string;
  nodeUuid: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date;
  checkoutEventUuid: string | null;
  plannedDate: Date;
  orderUuid: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export enum BillingsTaxiDriverUpdateParamsContributionType {
  BASE_AMOUNT_EXTERNAL_TAXI = "BASE_AMOUNT_EXTERNAL_TAXI",
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
  CONTRACT_CORRECTION_RATE = "CONTRACT_CORRECTION_RATE",
}

export type BillingsTaxiDriverUpdateParamsContributionContractCorrectionBaseAmountExternalTaxi =
  {
    type: BillingsTaxiDriverUpdateParamsContributionType.BASE_AMOUNT_EXTERNAL_TAXI;
    comment: string | null;
    distance: number;
    amount: number;
  };

export type BillingsTaxiDriverUpdateParamsContributionContractCorrectionRate = {
  type: BillingsTaxiDriverUpdateParamsContributionType.CONTRACT_CORRECTION_RATE;
  comment: string | null;
  rate: number;
};

export type BillingsTaxiDriverUpdateParamsContributionBonusFavorableDistance = {
  type: BillingsTaxiDriverUpdateParamsContributionType.BONUS_FAVORABLE_DISTANCE;
  comment: string | null;
  distance: number;
  rate: number;
};

export type BillingsTaxiDriverUpdateParamsContributionBonusOther = {
  type: BillingsTaxiDriverUpdateParamsContributionType.BONUS_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiDriverUpdateParamsContributionPenaltyWrongRoute = {
  type: BillingsTaxiDriverUpdateParamsContributionType.PENALTY_WRONG_ROUTE;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiDriverUpdateParamsContributionPenaltyBeingLate = {
  type: BillingsTaxiDriverUpdateParamsContributionType.PENALTY_BEING_LATE;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiDriverUpdateParamsContributionPenaltyIncompatibleCar = {
  type: BillingsTaxiDriverUpdateParamsContributionType.PENALTY_INCOMPATIBLE_CAR;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiDriverUpdateParamsContributionPenaltyOther = {
  type: BillingsTaxiDriverUpdateParamsContributionType.PENALTY_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsTaxiDriverUpdateParamsContributionContractCorrection =
  | BillingsTaxiDriverUpdateParamsContributionContractCorrectionBaseAmountExternalTaxi
  | BillingsTaxiDriverUpdateParamsContributionContractCorrectionRate;

export type BillingsTaxiDriverUpdateParamsContributionBonus =
  | BillingsTaxiDriverUpdateParamsContributionBonusFavorableDistance
  | BillingsTaxiDriverUpdateParamsContributionBonusOther;

export type BillingsTaxiDriverUpdateParamsContributionPenalty =
  | BillingsTaxiDriverUpdateParamsContributionPenaltyWrongRoute
  | BillingsTaxiDriverUpdateParamsContributionPenaltyBeingLate
  | BillingsTaxiDriverUpdateParamsContributionPenaltyIncompatibleCar
  | BillingsTaxiDriverUpdateParamsContributionPenaltyOther;

export type BillingsTaxiDriverUpdateParamsContribution =
  | BillingsTaxiDriverUpdateParamsContributionBonus
  | BillingsTaxiDriverUpdateParamsContributionPenalty
  | BillingsTaxiDriverUpdateParamsContributionContractCorrection;

type BillingsTaxiDriverUpdateParams = {
  billingUuid: string;
  billingNodes: BillingsTaxiDriverUpdateParamsNode[];
  billingContributions: BillingsTaxiDriverUpdateParamsContribution[];
};

export default BillingsTaxiDriverUpdateParams;
